import { lazy } from "react";

// Lazy loading
const pages = {
  Home: lazy(() => import("../../pages/Home/Home")),
  PosList: lazy(() => import("../../pages/PosList/PosListPage")),
  PosDetail: lazy(() => import("../../pages/PosDetail/PosDetail")),
  Profile: lazy(() => import("../../pages/Profile/Profile")),
  Ranking: lazy(() => import("../../pages/Ranking/Ranking")),
  Badges: lazy(() => import("../../pages/Badges/Badges")),
  Settings: lazy(() => import("../../pages/Settings/Settings")),
  SettingsMobileDescription: lazy(
    () =>
      import(
        "../../pages/Settings/MobileSettingsDescription/MobileSettingsDescription"
      ),
  ),
  SettingsMobilePreferences: lazy(
    () =>
      import(
        "../../pages/Settings/MobileSettingsPreferences/MobileSettingsPreferences"
      ),
  ),
  NotificationCenter: lazy(
    () => import("../../pages/Notifications/Notifications"),
  ),
  Materials: lazy(() => import("../../pages/Materials/Materials")),
  ProposalCreation: lazy(
    () => import("../../pages/ProposalCreation/ProposalCreation"),
  ),
  Training: lazy(() => import("../../pages/Trainings/Trainings")),
  Icons: lazy(() => import("../../pages/DevIcons/DevIcons")),
  PosDetailExternal: lazy(
    () => import("../../pages/PosDetailExternal/PosDetailExternal"),
  ),
  ProposalEco: lazy(() => import("../../pages/ProposalEco/ProposalEco")),
  ProposalExternal: lazy(
    () => import("../../pages/ProposalExternal/ProposalExternal"),
  ),
  Proposals: lazy(() => import("../../pages/Proposals/Proposals")),
  News: lazy(() => import("../../pages/News/News")),
  Media: lazy(() => import("../../pages/Media/Media")),
};

export default pages;
